import React from 'react';

interface TabGroupWrapperProps {
  groupLabel: string;
  groupColor: string;
  isActiveGroup: boolean;
  showSeparator?: boolean;
  children: React.ReactNode;
}

const TabGroupWrapper = ({
  groupLabel,
  groupColor,
  isActiveGroup,
  showSeparator = false,
  children,
}: TabGroupWrapperProps) => {
  const validChildren = React.Children.toArray(children).filter(Boolean);
  if (validChildren.length === 0) return null;

  return (
    <>
      {showSeparator && (
        <div className="tab-group-separator" />
      )}

      <div
        className="flex flex-col rounded-md transition-all duration-200"
        style={{
          backgroundColor: isActiveGroup ? `${groupColor}0D` : 'transparent',
          borderBottom: `4px solid ${groupColor}`,
          borderBottomColor: isActiveGroup ? groupColor : `${groupColor}4D`,
        }}
      >
        {/* Group label with dot */}
        <div className="hidden sm:flex items-center gap-1.5 px-2 pb-1 pt-0.5">
          <div
            className="w-2 h-2 rounded-full transition-opacity duration-200"
            style={{
              backgroundColor: groupColor,
              opacity: isActiveGroup ? 1 : 0.35,
            }}
          />
          <span
            className="tab-group-label transition-colors duration-200"
            style={{
              color: isActiveGroup ? groupColor : 'hsl(var(--muted-foreground))',
            }}
          >
            {groupLabel}
          </span>
        </div>

        {/* Tabs row */}
        <div className="flex gap-0">
          {validChildren}
        </div>
      </div>
    </>
  );
};

export default TabGroupWrapper;
